Whether the candidate applied to this associated position.

This is `false` for purchased profiles from the Proactive Sourcing use case.
